import {InjectionToken} from "@angular/core";

export interface DreambooksEditorApiModuleConfig {
  apiUrl?: string;
}

export const DREAMBOOKS_EDITOR_API_MODULE_CONFIG = new InjectionToken('DreambooksEditorApiModuleConfig');
